'use client';

import { useLocale } from 'next-intl';
import { COOKIE_PREFERENCES_OPEN_EVENT } from '@/shared/lib/privacy/cookieConsent';

type CookiePreferencesButtonProps = {
  readonly className?: string;
  readonly label?: string;
};

const CookiePreferencesButton = ({
  className,
  label,
}: CookiePreferencesButtonProps) => {
  const locale = useLocale();

  return (
    <button
      type="button"
      onClick={() =>
        window.dispatchEvent(new Event(COOKIE_PREFERENCES_OPEN_EVENT))
      }
      className={className}
    >
      {label ?? (locale === 'en' ? 'Cookie Preferences' : '쿠키 설정')}
    </button>
  );
};

export default CookiePreferencesButton;
